import {
    GET_BARCODE_ITEMS,
    SHOW_INVALID_BARCODE_DETAILS,
    SET_BARCODE_RECEIVE_ITEMS,
    SHOW_INVALID_BARCODE_POPUP,
    RESET_INVALID_BARCODE_DETAILS,
    RESET_BARCODE_ITEMS,
    SUCCESS_MESSAGE_CAMERA,
} from './actionTypes';

export const resetInvalidBarCodeDetails = () => {
    return {
        type: RESET_INVALID_BARCODE_DETAILS,
    };
};

export const getBarcodeItems = (payload) => {
    return {
        type: GET_BARCODE_ITEMS,
        payload: payload,
    };
};
export const showInvalidBarcodePoup = (payload) => {
    return {
        type: SHOW_INVALID_BARCODE_POPUP,
        payload: payload,
    };
};
export const invalidBarCodeDetails = (payload) => {
    return {
        type: SHOW_INVALID_BARCODE_DETAILS,
        payload: payload,
    };
};

export const setBarcodeDetails = () => {
    return {
        type: SET_BARCODE_RECEIVE_ITEMS,
        payload: '',
    };
};

export const resetBarcodeDetails = (payload) => {
    return {
        type: RESET_BARCODE_ITEMS,
        payload: payload,
    };
};

export const successMessageCamera = (payload) => {
    return {
        type: SUCCESS_MESSAGE_CAMERA,
        payload: payload,
    };
};
